import { CommonResponse } from '../../../../models/common';
import axiosClient from '../../../../utils/axiosClient';

const ROOT_API_ROUTE = 'element-unit-master';

const ElementUnitMasterService = {
  getAll(): Promise<CommonResponse<any>> {
    let url = `${ROOT_API_ROUTE}`;
    return axiosClient.get(url);
  },
};

export default ElementUnitMasterService;
